export interface PublicRecordingRoute {
  recordingId: string;
  external: boolean;
}

/** Only recipient URLs use the public recording entry point. */
export function publicRecordingRoute(pathname: string): PublicRecordingRoute | null {
  const match = pathname.match(
    /^\/video\/(recording|screen-recording)\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?$/i
  );
  return match
    ? { recordingId: match[2], external: match[1].toLowerCase() === 'screen-recording' }
    : null;
}

/** The token of a shared link address, /l/{token}. */
export function publicSharedLinkToken(pathname: string): string | null {
  const match = pathname.match(/^\/l\/([A-Za-z0-9_-]{16,64})\/?$/);
  return match ? match[1] : null;
}
